// Example presets for Background Change feature
export interface BackgroundChangeExamplePreset {
    id: number;
    name: string;
    clothPreview: string;
    results: string[];
    category?: string;
}

export const backgroundChangeExamplePresets: BackgroundChangeExamplePreset[] = [
    {
        id: 1,
        name: "Classic Look",
        clothPreview: "https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Fai-background-change%2Fdemo%2Fbackground-example-1.webp?alt=media&token=0d51aa35-b1e4-4038-b4f6-5b08e6679786",
        results: [
            "https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Fai-background-change%2Fdemo%2Fbackground-result-1.webp?alt=media&token=5032d328-1e9a-4b9a-968a-b298d74cb45e"
        ],
        category: "classic"
    },
    {
        id: 2,
        name: "Luxury Style",
        clothPreview: "https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Fai-background-change%2Fdemo%2Fbackground-example-2.webp?alt=media&token=893c1b4f-d186-48f4-9045-0894f8c6ee43",
        results: [
            "https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Fai-background-change%2Fdemo%2Fbackground-result-2.webp?alt=media&token=1c9b6fb0-1847-4424-8d44-ebd03b708029"
        ],
        category: "luxury"
    },
    {
        id: 3,
        name: "Office Professional",
        clothPreview: "https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Fai-background-change%2Fdemo%2Fbackground-example-3.webp?alt=media&token=e42609ea-0714-494c-8c35-91fb04520520",
        results: [
            "https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Fai-background-change%2Fdemo%2Fbackground-result-3.webp?alt=media&token=445fa012-f0ac-4747-a599-4493677c4cbb"
        ],
        category: "office"
    }
];
